/* eslint-disable */
import cttqMito from "./mito/cttqMito";
import cttqSentry from "./sentry/cttqSentry";
export const choosetype = (mitotype) => {
  switch (mitotype) {
    case "mito":
      return cttqMito;
    case "sentry":
      return cttqSentry;
    default:
      return cttqMito;
  }
};
const CttqMonitor = (option) => {
  return choosetype(option);
};
export default CttqMonitor;

